/**
 * API Slice (Redux Toolkit Query)
 *
 * This file defines the RTK Query API slice for the application.
 * Note: With Redis sessions, API calls to Django go through Next.js API routes
 * (using serverPostCall/getCall) which handle auth from Redis sessions.
 * This RTK Query slice is kept for any remaining client-side API needs.
 */

import { API_URL } from "@/baseUrl";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL as string,
    prepareHeaders: async (headers) => {
      headers.set("X-Dev-Domain", "cashlessai.coffeeshop.com");
      // Auth tokens are now stored in Redis server-side.
      // All authenticated API calls go through Next.js API routes.
      return headers;
    },
  }),
  tagTypes: [],
  endpoints: (builder) => ({}),
  refetchOnFocus: true,
  refetchOnReconnect: true,
});
